<template>
  <label class="kd-icon-box" @click="handleBox" :class="[{ 'is-web': isWeb }]">
    <span class="text" v-if="leftText">{{ leftText }}</span>
    <span class="target">
      <component
        v-bind:is="kd"
        :size="size"
        :strokeWidth="strokeWidth"
        :fill="fill"
      ></component>
    </span>
    <span class="text" v-if="rightText">{{ rightText }}</span>
  </label>
</template>

<script>
import { isEnvMobile } from '@/common/utils';
export default {
  name: 'kd-icon-component',
  data() {
    return {
      kd: null,
      isWeb: false,
      initSize: null,
      initTextSize: null,
    };
  },
  props: {
    icon: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 16,
    },
    strokeWidth: {
      type: Number,
      default: 1,
    },
    margin: {
      type: String,
      default: '',
    },
    fill: {
      type: String,
      default: 'currentColor',
    },
    leftText: {
      type: String,
      default: '',
    },
    rightText: {
      type: String,
      default: '',
    },
    textSize: {
      type: String,
      default: '14',
    },
  },
  methods: {
    handleBox() {
      this.$emit('click');
    },
  },
  async beforeMount() {
    this.initSize = this.size + 'px';
    this.initTextSize = this.textSize + 'px';
    this.isWeb = isEnvMobile();
    if (this.isWeb) {
      this.initSize = (this.size * 3 * 640) / 1080 / 100 + 'rem';
      this.initTextSize = (this.textSize * 3 * 640) / 1080 / 100 + 'rem';
    }
    const _kd = await import('@kdocs/kdesign-icons-vue');
    this.kd = _kd[`${this.icon}`];
  },
};
</script>

<style lang="scss" scoped>
.kd-icon-box {
  display: flex;
  align-items: center;
  justify-content: center;

  :deep(span),
  :deep(i) {
    vertical-align: super;
    font-size: px2rem(32);
    display: flex;
  }
  &.is-web {
    .target {
      margin-right: 0;
    }
    .text {
      margin-left: px2rem(8);
    }
    .target :deep(svg) {
      width: 100%;
      height: 100%;
    }
  }
  .target {
    width: v-bind(initSize);
    height: v-bind(initSize);
    margin-right: 6px;
  }
  .text {
    font-size: v-bind(initTextSize);
  }
}
</style>
